import React, { useEffect, useState } from "react";
import CheckoutCard from "../components/CheckoutCard/CheckoutCard";
import CheckoutDetails from "../components/CheckoutDetails/CheckoutDetails";
import { getCheckoutCart, getUserCart } from "../appState/slices/cart/cartSlice";
import { useDispatch, useSelector } from "react-redux";
import { CaretDown, CaretUp } from "phosphor-react";

const Checkout = () => {
    const checkoutcart = useSelector(state => state.cart.checkoutcart);
    const dispatch = useDispatch();

    // Collapse state (collapsed on mobile, open on desktop)
    const [showItems, setShowItems] = useState(window.innerWidth > 768);

    useEffect(() => {
        dispatch(getCheckoutCart());
    }, []);

    return (
        <div className="checkoutcontainer">
            <div className="checkout">
                <div className="container-fluid">
                    <div className="row">

                        {/* ========================================= */}
                        {/* LEFT SIDE - COLLAPSIBLE PRODUCT LIST ONLY */}
                        {/* ========================================= */}
                        <div className="col-lg-6 col-md-6 col-sm-12">

                            {/* Collapsible Header */}
                            <div 
                                className="checkout-collapse-header"
                                onClick={() => setShowItems(!showItems)}
                            >
                                <span className="font-medium">ORDER ITEMS ({checkoutcart?.items?.length})</span>
                                <span className="chevron">{showItems ? <CaretDown size={18} /> : <CaretUp size={18} />}</span>
                            </div>

                            {/* Collapsible Cards Section */}
                            <div className={`checkout-collapse ${showItems ? "open" : ""}`}>
                                {checkoutcart.items?.map((item, index) => (
                                    <div className="col-12 ps-0 pe-1 pb-1" key={index}>
                                        <CheckoutCard 
                                            image={item.product.defaultImageUrl}
                                            product={item}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* ========================================= */}
                        {/* RIGHT SIDE - DO NOT COLLAPSE THIS PART     */}
                        {/* ========================================= */}
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <CheckoutDetails />
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default Checkout;
